import { Fragment } from 'react'

import {
  Logout03Icon,
  SecurityPasswordIcon,
  UserIcon
} from '@hugeicons/react'
import { useAuthActions } from '@/shared/lib/auth/actions'
import { Link } from '@/shared/ui/Link'

import { useAppMenu } from './AppMenuContext'

type AppMenuQuickActionsProps = {
  basePathWithId: string
  showAdditionalInfo: boolean
}

type QuickAction = {
  slug: string
  label: string
  icon: typeof UserIcon
  href?: string
  onClick?: () => void
  danger?: boolean
}

const itemClass =
  'flex min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-1.5 border-0 bg-transparent px-0.5 py-1 no-underline'

export function AppMenuQuickActions({
  basePathWithId,
  showAdditionalInfo
}: AppMenuQuickActionsProps) {
  const { close, onRequestEditAdditionalInfo } = useAppMenu()
  const { signOut } = useAuthActions()

  const handleSignOut = async () => {
    close()
    await signOut({ confirm: true, callbackUrl: basePathWithId || '/' })
  }

  const actions: QuickAction[] = [
    // "Editar Avatar" saiu daqui: o editor passou a ser alcançado pela seção de
    // perfil de "Minha conta", e manter a entrada seria um segundo caminho para
    // o mesmo destino.
    {
      slug: 'profile',
      label: 'Minha conta',
      icon: UserIcon,
      href: `${basePathWithId}/minha-conta`
    },
    ...(showAdditionalInfo
      ? [
          {
            slug: 'info',
            label: 'Informações',
            icon: SecurityPasswordIcon,
            onClick: () => {
              close()
              onRequestEditAdditionalInfo?.()
            }
          }
        ]
      : []),
    {
      slug: 'sign-out',
      label: 'Sair',
      icon: Logout03Icon,
      onClick: handleSignOut,
      danger: true
    }
  ]

  return (
    <div className="relative z-[3] -mt-3.5 mx-3.5 flex items-stretch rounded-xl bg-white px-1 py-3 shadow-[0_6px_20px_rgba(76,44,130,0.12)]">
      {actions.map((action, index) => {
        const Icon = action.icon
        const content = (
          <>
            <Icon
              size={22}
              variant="stroke"
              className={
                action.danger ? 'text-[var(--color-danger)]' : 'text-[var(--color-brand)]'
              }
            />
            <span className="text-center text-2xs leading-[1.15] font-semibold text-gray-700">
              {action.label}
            </span>
          </>
        )

        return (
          <Fragment key={action.slug}>
            {index > 0 && (
              <div className="my-1 w-px shrink-0 self-stretch bg-[#ececf2]" />
            )}
            {action.href ? (
              <Link href={action.href} className={itemClass} onClick={close}>
                {content}
              </Link>
            ) : (
              <button type="button" className={itemClass} onClick={action.onClick}>
                {content}
              </button>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
